import { useState } from "react";
import { ALL, NONE } from "@miplatform/constants";
import { useComponentState, useDebounce } from "@miplatform/hooks";
import { buildSearchQuery } from "@miplatform/utils";
import { useHomes } from "@mibuildweb/hooks";
import { FilterObject, GetHomesParams } from "../types";

export const useHomesViewModel = (initialSearch = "") => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const [search, setSearch] = useState<string>(initialSearch);
  const debouncedSearch = useDebounce(search);

  const {
    getHomes: fetchHomes,
    homes: homesListData,
    setHomes: setHomesListData,
    deleteHome,
  } = useHomes();

  const getHomes = (params: GetHomesParams = {}) => {
    const { filters, skip, top } = params;
    const searchQuery = buildSearchQuery(search, ["address/addressLine1"]);
    const filterObj: FilterObject = { ...searchQuery };

    let sortBy = "address/addressLine1 asc";

    if (filters) {
      if (filters.builderId && filters.builderId !== ALL) {
        filterObj.builderId = {
          type: "guid",
          value: filters.builderId,
        };
      }
      if (filters.communityId && filters.communityId !== ALL) {
        filterObj.communityId = {
          type: "guid",
          value: filters.communityId,
        };
      }

      if (filters.phase && filters.phase !== ALL) {
        filterObj.phase = {
          eq: filters.phase,
        };
      }
      if (filters.latestTemplateName && filters.latestTemplateName !== ALL) {
        filterObj.latestTemplateName = {
          contains: filters.latestTemplateName,
        };
      }

      if (filters.sortBy && filters.sortBy !== NONE) {
        if (filters.sortBy === "startDate") {
          sortBy = "modifiedOn desc";
        } else if (filters.sortBy === "closingDate") {
          sortBy = "closingDate asc";
        }
      }
    }

    return fetchHomes({
      skip,
      top,
      filters: filterObj,
      sort: sortBy,
    });
  };

  return {
    isLoading,
    homesListData,
    stateManager,
    getHomes,
    setHomesListData,
    search,
    setSearch,
    debouncedSearch,
    handleHomeDeletion: deleteHome,
  };
};
